import Vue from 'vue'
import axios from 'axios'
import Store from '@/store/index'
import Router from '@/router/index'
import Nprogress from 'nprogress'
import 'nprogress/nprogress.css'

let service: any

service = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_URL : '/api',
  timeout: 60000
})

// request interceptors:
service.interceptors.request.use(
  (config: any) => {
    Nprogress.start()
    config.headers.authorization = Store.state.User.token
    return config
  },
  (error: any) => {
    return Promise.reject(error)
  }
)

// response interceptors:
service.interceptors.response.use(
  (response: any) => {
    Nprogress.done()
    if (response.data.code === 402 || response.data.code === 401) {
      Store.commit('User/removeTokenForUser')
      Store.commit('User/removeUserInfoForUser')
      Router.push('/')
    }
    return response
  },
  (error: any) => {
    return Promise.reject(error)
  }
)

export default service
